import React, { Component } from 'react'
import { connect } from 'react-redux'
import {getCreditLimitModelData,updateCreditLimitModelRequest} from './action'
import { Form,Col, Row, Button,Card, CardBody,Input,FormGroup, Label} from 'reactstrap';
import { Field,reduxForm, FieldArray } from 'redux-form';
import { Preloading } from '../../../components/UI/Preloader/action';
import {toast } from 'react-toastify';
import DropDownSelect from './DropDownSelect';

class EditCreditLimitComponent extends Component {
     constructor(props) {
         super(props);
         this.state = {
            variableFiledTypeDropdownOptions:["FORMULA","DROPDOWN","TEXTFIELD"],
            variableFields:[],
            creditLimitModelUpdateResponse:[]
         };
      }
    
    componentDidMount(){
      this.props.getCreditLimitModelData(this.props.match.params.modelId)
        this.props.initialize({
             dataValues: [{
                displayName: '',
                elementName: '',
                masterKey: '',
                type: '',
                value:''
             }]
         });
      this.props.preloading(true)
    }  

    componentDidUpdate(prevProps) {
        if (this.props.creditLimitModelData !== prevProps.creditLimitModelData) {
         this.props.preloading(false)
            this.setState({
               variableFields:this.props.creditLimitModelData 
            })
            this.props.initialize({
                dataValues:this.props.creditLimitModelData.dataValues
            })
        }
        if (this.props.creditLimitModelUpdateResponse !== prevProps.creditLimitModelUpdateResponse) {
             toast.success(<div>
               <i className="fa fa-success"></i>&nbsp;Credit limit template updated !  
            </div>);   
         }
    }

    handleFormSubmit = (event)=>{
        event.preventDefault()
        let comboLength = (event.target.elements.length-2) / 5
        if (comboLength === 0) {
           toast.error(<div>
              <i className="fa fa-warning"></i>&nbsp;Empty model can&#39;t be submitted !
           </div>);
        }
        else{
           let request = this.createRequest(event.target.elements)
           this.props.updateCreditLimitModelRequest(request.creditLimitModelObj)
           
        }
    }

    createRequest = (elems) => {
        let creditLimitModelObj = {}
        creditLimitModelObj.name = this.state.variableFields.name;
        creditLimitModelObj.id = this.props.match.params.modelId;
        let dataValues = []
        let comboLength = (elems.length-2) / 5
        for(let i = 0; i< comboLength; i++) {
            if(elems[`dataValues[${i}].displayName`].value){
              dataValues[i] = {
                displayName : elems[`dataValues[${i}].displayName`].value,
                elementName : elems[`dataValues[${i}].elementName`].value,
                masterKey : elems[`dataValues[${i}].masterKey`].value,
                type : elems[`dataValues[${i}].type`].value,
                value : elems[`dataValues[${i}].value`].value
               }
            }
            else{
              toast.error(<div>
                 <i className="fa fa-warning"></i>&nbsp;Field Name Empty !
              </div>);
            }
         }
        creditLimitModelObj.dataValues=dataValues;
        return {
           creditLimitModelObj
         }
      }

    render() {
      return(
        <Col>
            <div className="d-flex justify-content-between align-items-center mb-3">
               <h4 className="mb-0">{this.state.variableFields.name}</h4>
            </div>
            <Card>
               <CardBody>
                  <Form onSubmit={(e) => this.handleFormSubmit(e)}>
                     <Row className="mt-3">   
                        <Col sm='4' className="ml-3"><label>Name<span className="text-danger">*</span></label></Col>
                        <Col sm='4'><label>Element Name</label></Col>
                        <Col sm='4'><label>Master Key</label></Col>
                        <Col sm='4'><label>Field Type</label></Col>
                        <Col sm='4'><label>Field Value</label></Col>
                     </Row>
                     <FieldArray name='dataValues' component={renderMembers} dropDownOptions={this.state.variableFiledTypeDropdownOptions} required/> 
                     <div>
                        <button type="submit" className="btn btn-info">Save</button>
                     </div>
                  </Form>
               </CardBody>
            </Card>
         </Col>   
      );  
   }
}

const mapStateToProps = (state, ownProps) => ({
    creditLimitModelData:state.creditLimitModelData.creditLimitModelDataSuccess,
    creditLimitModelUpdateResponse:state.creditLimitModelData.updateCreditLimitModelResponse
})

const mapDispatchToProps = (dispatch, ownProps) => ({
   
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    getCreditLimitModelData:id => {dispatch(getCreditLimitModelData(id));},
    updateCreditLimitModelRequest:data => {dispatch(updateCreditLimitModelRequest(data));}
})

export default reduxForm({
    form: 'EditCreditLimitComponent'
 })(connect(mapStateToProps, mapDispatchToProps)(EditCreditLimitComponent))

 const renderMembers = ({ fields ,dropDownOptions ,meta: { error, submitFailed } }) => {
   return (<ul>
        {fields.map((member, index) => (
            <li key={index}>  
             <Row className="d-flex align-items-center mb-3">    
                <Col sm="4" className="px-2">
                  <Field name={`${member}.displayName`} className="p-2 w-100 radius-5 border risk-grade-input" type="text" placeholder="Name" component="input"/>
                </Col>
                <Col sm="4" className="px-2">
                     <Field name={`${member}.elementName`} className="p-2 w-100 radius-5 border risk-grade-input" type="text" placeholder="Element Name" component="input"/>
                </Col>
                <Col sm="4" className="px-2">
                     <Field name={`${member}.masterKey`} className="p-2 w-100 radius-5 border risk-grade-input" type="text" placeholder="Master Key" component="input"/>
                </Col>
                <Col sm="4" className="px-2">
                   <Field
                   name={`${member}.type`}
                   type="text"
                   component={DropDownSelect}
                   label="State"
                   data={dropDownOptions}
                   />
                </Col>
                <Col sm="4" className="px-2">
                     <Field name={`${member}.value`} type="textarea" className="p-2 w-100 radius-5 border risk-grade-input" placeholder="Value" component="textarea"/>
                </Col> 
                <Col sm="1" className="px-2 text-right"><a onClick={() => fields.remove(index)}><i className="icon-close text-danger pointer"></i></a> </Col>
             </Row>
             <br/>
            </li>
        ))}
          <Row>
             <Button type="button" className="d-flex ml-auto text-primary text-decoration-none pr-4 pt-0" color="link" onClick={() => fields.push({})}><i className="icon-plus mr-2 text-decoration-none"></i>Add More</Button>
          </Row>
      </ul>)}